module.exports = {
  "country": "AZ",
  "artist": "Safura",
  "song": "Drip Drop",
  "year": "2010",
  "place": "5",
  "spotify": "38hIyhovrQzznCiNjnG5LI"
};